import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { lang } from "../assets/languages/en.language";

export default function TermsCompliance() {
  return (
    <LinkTextButton to={import.meta.env.VITE_TERMS_LINK} target="_blank" rel="noopener noreferrer">
      {lang.landingPage.terms_compliance_button}
    </LinkTextButton>
  );
}

const LinkTextButton = styled(Link)`
  cursor: pointer;
  text-align: center;
  color: ${(props) => props.theme.color.tertiaryLight} !important;
  font-size: ${(props) => props.theme.font.size.title.small};
  font-family: ${(props) => props.theme.font.family.main};
`;
